import { Icon } from "components/Icon";
import { cn } from "utils/styling";

export const AddressMapMarker = ({ className }: { className?: string }) => {
  return (
    <div className={cn("pointer-events-none h-12 w-12", className)}>
      <Icon
        className="h-12 w-12 "
        color="var(--core-color-leaftech-blue-500)"
        iconName="MapMarker"
        svgClassName="h-12 w-12"
      />
    </div>
  );
};
